var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5427 13.2322C15.4765 12.0196 16.0318 10.5003 16.0318 8.85142C16.0318 4.88378 12.8165 1.6665 8.84917 1.6665C4.88181 1.6665 1.6665 4.88378 1.6665 8.85142C1.6665 12.8191 4.88181 16.0363 8.84917 16.0363C10.5 16.0363 12.0205 15.4793 13.2335 14.543L17.0232 18.3332L18.3332 17.0231L14.5427 13.2322ZM14.1793 8.85142C14.1793 11.7963 11.7929 14.1835 8.84917 14.1835C5.90544 14.1835 3.51908 11.7963 3.51908 8.85142C3.51908 5.90656 5.90544 3.51928 8.84917 3.51928C11.7929 3.51928 14.1793 5.90656 14.1793 8.85142Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search_icon.7914f0490cb30b5a1a879ec9746ca576.svg";
export { ForwardRef as ReactComponent };